var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.bottom.v-secondary",modifiers:{"hover":true,"bottom":true,"v-secondary":true}}],key:_vm.tag.key,staticClass:"pointer",class:( _obj = {
        isSelected: _vm.currState == _vm.tag.key
    }, _obj[("border-" + (_vm.tag.style))] = true, _obj ),attrs:{"variant":_vm.tag.style,"title":_vm.tag.help},on:{"click":function($event){return _vm.onClick(_vm.tag.key)}}},[_vm._v(" "+_vm._s(_vm.tag.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }